import AppNameAsLogo from "../components/AskTheBil";

const AboutPage = () => {
  return (
    <div className="bg-gray-100 text-gray-800 min-h-screen py-10 px-4 mt-10">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <header className="text-center mb-10">
          <h1 className="text-2xl font-bold mb-4 flex items-center gap-2 justify-center align-middle">
            <div className="mb-1">About</div>
            <AppNameAsLogo />
          </h1>
          <p className="text-lg text-gray-600">
            Simplifying legislative bills and empowering individuals with
            knowledge.
          </p>
        </header>

        {/* Who We Are Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Who We Are</h2>
          <p className="text-gray-700">
            <strong>Ask the Bill</strong> is a platform designed to simplify and
            demystify legislative bills for the public. Our mission is to bridge
            the gap between legal jargon and everyday understanding, empowering
            individuals to make informed decisions.
          </p>
        </section>

        {/* Mission Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              To make legislative information accessible, understandable, and
              actionable for everyone.
            </li>
            <li>
              Promote civic engagement by helping individuals understand how
              bills impact their lives.
            </li>
            <li>
              Provide a reliable space for exploring legislative documents.
            </li>
          </ul>
        </section>

        {/* What We Do Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">What We Do</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              <strong>Simplified Explanations of Bills:</strong> Transforming
              legislative texts into digestible content.
            </li>
            <li>
              <strong>Interactive Q&A:</strong> Users can ask specific questions
              and receive tailored answers.
            </li>
            <li>
              <strong>Bill Exploration:</strong> Explore a growing database of
              legislative bills with detailed insights.
            </li>
            <li>
              <strong>Civic Education:</strong> Learn about the legislative
              process and how to engage effectively.
            </li>
          </ul>
        </section>

        {/* Why Choose Us Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Why Choose Us?</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              <strong>Clarity:</strong> Breaking down legal jargon into everyday
              language.
            </li>
            <li>
              <strong>Reliability:</strong> Ensuring accuracy in all the details
              we provide.
            </li>
            <li>
              <strong>User-Friendly:</strong> Offering an intuitive interface
              for effortless exploration.
            </li>
            <li>
              <strong>Inclusive:</strong> Designed for individuals,
              organizations, and communities alike.
            </li>
          </ul>
        </section>

        {/* Join Our Community Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Join Our Community</h2>
          <p className="text-gray-700 mb-4">
            Stay informed, stay empowered. At <strong>Ask the Bill</strong>, we
            believe that knowledge is power, and we’re here to ensure that
            legislative information is accessible to everyone.
          </p>
          <p className="text-gray-700">
            Follow us on{" "}
            <a
              href="https://x.com/Ask_The_Bill"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              Twitter
            </a>
            ,{" "}
            <a
              href="https://www.facebook.com/share/1Ethuzz5Zi/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              Facebook
            </a>
            , and{" "}
            <a
              href="https://linkedin.com/company/ask-the-bill"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              LinkedIn
            </a>{" "}
            to stay updated with the latest bills and insights.
          </p>
        </section>

        {/* Contact Section */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="text-gray-700">
            Have questions, suggestions, or feedback? Reach out to us!
          </p>
          <ul className="list-none space-y-2 mt-4 text-gray-700">
            <li>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:social@askthebill.com"
                className="text-blue-500 hover:underline"
              >
                social@askthebill.com
              </a>
            </li>
            <li>
              <strong>Website:</strong>{" "}
              <a
                href="https://ask-the-bill.onrender.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                www.askthebill.com.ng
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
